import DateFormatter from 'formatters/DateFormatter';

function HearingDateTimeFormatter(props) {
	const { text, rowData } = props;
	const scheduledHearingDate = rowData?.scheduled_hearing_date || text;
	const scheduledHearingTime = rowData?.scheduled_hearing_time;

	if (!scheduledHearingDate && !scheduledHearingTime) {
		return <span>-</span>;
	}

	const datePart = scheduledHearingDate ? <DateFormatter text={scheduledHearingDate} /> : null;
	const timePart = scheduledHearingTime ? <span> {scheduledHearingTime}</span> : null;

	return (
		<span>
			{datePart}
			{timePart}
		</span>
	);
}

export default HearingDateTimeFormatter;
